<script lang="ts">
    
    import { fly } from "svelte/transition";
    import { notifications, removeNotification } from "../../Services/ui";

</script>

<div class="notifications">
    {#each $notifications as notification}
        <div
            transition:fly={{ x: 100 }}
            class="notification rounded {notification.type}"
            on:click={() => removeNotification(notification)}>{notification.content}</div>
    {/each}
</div>

<style lang="scss">

    .notifications {
        position: fixed;
        z-index: 1100;
        bottom: 1rem;
        right: 1rem;
        display: flex;
        flex-direction: column;
        gap: 1rem
    }

    .notification {
        padding: 0.5rem;
        background-color: var(--color-primary);
        color: #fff;

        &.success {
            background-color: var(--color-success);
        }

        &.fail {
            background-color: var(--color-invalid);
        }
    }

</style>
